import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export async function fetchDashboardById(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: DocType.DASHBOARD });
}

export async function saveDashboard(app, params) {
  const result = await common.saveDoc(app, {
    source: params.data,
    doc: params.data,
    docType: DocType.DASHBOARD,
  });

  return result;
}

export async function fetchDashboardDropdown(app, params) {
  const { searchTerm, searchParams, id } = params;
  const dropdown_type = `${DocType.DASHBOARD}/dropdown`;
  const query = {
    id,
    dropdown_type,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export async function fetchPortletReportDropdown(app, params) {
  const { searchTerm, searchParams, id } = params;
  const dropdown_type = 'dashboard/portlet_report/dropdown';
  const query = {
    id,
    dropdown_type,
    searchTerm,
    methodType: 'post',
    ...(searchParams || {}),
  };

  return common.getDropdownList(app, { query });
}

export async function fetchPortletReportById(app, id) {
  const service = app.service('dashboard/portlet_report');
  const data = service.get(id);
  return data;
}

export async function deleteDashboard(app, id) {
  return common.deleteDoc(app, {
    id,
    docType: DocType.DASHBOARD,
  });
}
